const MIMIC_KEY = 'mimicUser';

export const getMimicUser = () => {
  try {
    const raw = window.localStorage.getItem(MIMIC_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setMimicUser = (mimic) => {
  if (!mimic) {
    window.localStorage.removeItem(MIMIC_KEY);
  } else {
    window.localStorage.setItem(MIMIC_KEY, JSON.stringify(mimic));
  }
  window.location.reload();
};

export const clearMimicUser = () => setMimicUser(null);
